import React from "react";
import { AvatarGrid } from "@/components/avatar/AvatarGrid";

const AvatarSelection = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-foreground">
          Seleção de Avatar
        </h2>
        <p className="text-muted-foreground">
          Escolha um novo avatar para seu perfil
        </p>
      </div>
      <AvatarGrid />
    </div>
  );
};

export default AvatarSelection;
